import React from "react";
import { useNavigate } from "react-router-dom";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Divider from "@amzn/meridian/divider";
import { Icon } from "@amzn/meridian";
import checkCircleFilledTokens from "@amzn/meridian-tokens/base/icon/check-circle-filled";
import PillButton from "src/components/UI/PillButton";
import "../landing/landing.scss"
import "./classification.scss";

const SummaryRow: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <Column spacing="100" spacingInset="400 none">
    <Text type="b100" color="secondary"><b>{label}</b></Text>
    <Text type="b300">{value}</Text>
  </Column>
);

interface AddToContainerSuccessPageProps {
  productName: string;
  asin: string;
  containerName: string;
}

const AddToContainerSuccessPage: React.FC<AddToContainerSuccessPageProps> = ({
  productName,
  asin,
  containerName,
}) => {
  const navigate = useNavigate();

  return (
      <Column
        alignmentHorizontal="center"
        alignmentVertical="center"
        spacing="500"
        spacingInset="500"
        className="app-gradient-bg pwa-scrollable"
      >
        {/* Checkmark + heading */}
        <Column alignmentHorizontal="center" spacing="300">
          <Icon tokens={checkCircleFilledTokens} color="success" />
          <Text type="h300" alignment="center" color="success">
            Product Successfully{"\n"}Added
          </Text>
        </Column>

        <Column className="home-card" spacingInset="400">
          <SummaryRow label="PRODUCT" value={productName} />
          <Divider />
          <SummaryRow label="ASIN" value={asin} />
          <Divider />
          <SummaryRow label="CONTAINER" value={containerName} />
        </Column>

        {/* Scan another */}
        <PillButton
          text="SCAN ANOTHER TOTE/PRODUCT"
          color="secondary"
          onClick={() => navigate("/classification/scan")}
        />
      </Column>
  );
};

export default AddToContainerSuccessPage;
